/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DisconnectedUsageStateEnum } from './disconnectedUsageStateEnum';
import { OperationOriginEnum } from './operationOriginEnum';
import { VlsrPersonaEnum } from './vlsrPersonaEnum';


export interface DisconnectedUsageResponse { 
    /**
     * Disconnected SRM pair UUID
     */
    entity_uuid: string;
    org_id: string;
    state: DisconnectedUsageStateEnum;
    persona: VlsrPersonaEnum;
    quantity: number;
    expiry_ts: Date;
    id?: number;
    created_by?: OperationOriginEnum;
    created_ts?: Date;
    updated_by?: OperationOriginEnum;
    updated_ts?: Date;
}
export namespace DisconnectedUsageResponse {
}


